import { Filmomtale, Genre } from '@filmweb/sanity-types';
import { toRem } from 'lib/client/fonts';
import styled from 'styled-components';

//#region [Styles]

const SShortFacts = styled.div`

	text-align: center;
	font-weight: var(--font_bold);


	span:not(:last-child) {
		margin-right: 18px;
	}

	span:first-child {
		display: block;
		margin-right: 0;
	}

	@media screen and (min-width: 641px) {
		font-size: ${toRem(25)};
		margin-bottom: 1em;

		span:first-child {
			display: inline;
		}

		span:not(:last-child) {
			margin-right: 25px;
		}
	}

`;

//#endregion

//#region [Props]
type ShortFactsProps = {
	filmomtale?: Filmomtale | null;
	className?: string;
};
//#endregion

//#region [Component]
export default function ShortFacts({ filmomtale, className }: ShortFactsProps) {
	if (!filmomtale) {
		return null;
	}
	return <SShortFacts className={className}>
		{(filmomtale.genres?.length ?? 0) > 0 && <span>
			{filmomtale.genres?.map(genre => (genre as Genre).name).join(" / ")}
		</span>}

		{filmomtale.runningTime && <span>{filmomtale.runningTime}</span>}

		{filmomtale.ageRating?.age && <span>{filmomtale.ageRating.age}</span>}

	</SShortFacts>;
}
//#endregion